
import {
    PI_PRODUCT,
    PI_PRODUCT_SUCCESS,
    PI_PRODUCT_ERROR,
    PI_ATC_LIST,
    PI_ATC_LIST_SUCCESS,
    PI_ATC_LIST_ERROR,
    PI_ATC,
    PI_ATC_SUCCESS,
    PI_ATC_ERROR,
    PI_PHARMACEUTICAL_FORM,
    PI_PHARMACEUTICAL_FORM_SUCCESS,
    PI_PHARMACEUTICAL_FORM_ERROR,
    PI_PRESENTATION,
    PI_PRESENTATION_SUCCESS,
    PI_PRESENTATION_ERROR,
    PI_LIST,
    PI_LIST_SUCCESS,
    PI_LIST_ERROR,
    PI_LIST_SEARCH_CHANGE,
    PI_LIST_PAGE_SET,
    PI_EDIT_MODAL_SET,
    PI_EDIT_CHANGE_SET,
    PI_EDIT,
    PI_EDIT_SUCCESS,
    PI_EDIT_ERROR,
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    product: {
        loading: false,
        data: []
    },
    atclist: {
        loading: false,
        data: []
    },
    atc: {
        loading: false,
        data: []
    },
    pharmaceuticalform: {
        loading: false,
        data: []
    },
    presentation: {
        loading: false,
        data: []
    },
    edit: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            product: '',
            presentation: '',
            pharmaform: '',
            atc: '',
            code_atc:''
        },
        value: {
            product: '',
            presentation: '',
            pharmaform: '',
            atc: '',
            code_atc:''
        }
    }
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case PI_PRODUCT:
            return {
                ...state,
                loading: true,
                product: {
                    ...state.product
                }
            }
        case PI_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                product: {
                    ...state.product,
                    ...action.payload
                }
            }
        case PI_PRODUCT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case PI_ATC_LIST:
            return {
                ...state,
                loading: true,
                atclist: {
                    ...state.atclist
                }
            }
        case PI_ATC_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                atclist: {
                    ...state.atclist,
                    ...action.payload
                }
            }
        case PI_ATC_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case PI_ATC:
            return {
                ...state,
                loading: true,
                atc: {
                    ...state.atc
                }
            }
        case PI_ATC_SUCCESS:
            return {
                ...state,
                loading: false,
                atc: {
                    ...state.atc,
                    ...action.payload
                }
            }
        case PI_ATC_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case PI_PHARMACEUTICAL_FORM:
            return {
                ...state,
                loading: true,
                pharmaceuticalform: {
                    ...state.pharmaceuticalform
                }
            }
        case PI_PHARMACEUTICAL_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                pharmaceuticalform: {
                    ...state.pharmaceuticalform,
                    ...action.payload
                }
            }
        case PI_PHARMACEUTICAL_FORM_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case PI_PRESENTATION:
            return {
                ...state,
                loading: true,
                presentation: {
                    ...state.presentation
                }
            }
        case PI_PRESENTATION_SUCCESS:
            return {
                ...state,
                loading: false,
                presentation: {
                    ...state.presentation,
                    ...action.payload
                }
            }
        case PI_PRESENTATION_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case PI_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }

        case PI_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case PI_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case PI_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case PI_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case PI_EDIT_MODAL_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: action.payload
                }
            }
        case PI_EDIT_CHANGE_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        ...action.payload
                    }
                }
            }
        case PI_EDIT:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false
                }
            }
        case PI_EDIT_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case PI_EDIT_ERROR:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        default:
            return { ...state };
    }
};